var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.boxStyle,
      attrs: { disabled: _vm.disabled },
      on: { click: _vm.boxSelect }
    },
    [
      _c(
        "span",
        [
          _c("q-icon", {
            attrs: {
              width: "20px",
              name: "checkBoxOff",
              altName: "checkBoxOn",
              active: _vm.isActive,
              allowSelfUpdate: false
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              class: {
                "box-text": true,
                bold: _vm.boldLabels,
                "spaced-labels": _vm.spacedLabels
              },
              style: { "font-size": _vm.customFontSize }
            },
            [_vm._v("\n      " + _vm._s(_vm.label) + "\n\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50b996ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50b996ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/form/customItems/CheckBox.vue
// module id = null
// module chunks = 